import Vue from 'vue'
import Router from 'vue-router'


/**xs start */
// import start_page from '@/views/index/start_page'
import tabbar_index_index from '@/views/tabbar/index/index'
import tabbar_cart_index from '@/views/tabbar/cart/index'
import tabbar_goods_index from '@/views/tabbar/goods/index'
import tabbar_user_index from '@/views/tabbar/user/index'
//import tabbar from '@/views/tabbar/tabbar'
import shop_list from '@/views/shop/list'
import goods_detail from '@/views/goods/detail'
import order_list from '@/views/order/list'
// import order_detail from '@/views/order/detail'
import order_confirm from '@/views/order/confirm'
import order_addr_list from '@/views/order/addr_list'
import order_addr_edit from '@/views/order/addr_edit'
import user_login from '@/views/user/login'
import common_web from '@/views/common/web'
import user_liushui_list from '@/views/user/liushui_list'




Vue.use(Router)


const router = new Router({
// export default new Router({
	mode: 'history',//'hash', //history,美化url
	//base:'/aeongiftcardh5', //history时，按需增加
	routes: [
		// { path: '/start_page', name: 'start_page', component: start_page , meta: { title: '我爱热干面' } },
		{ path: '/', name: 'tabbar_index_index', component: tabbar_index_index , meta: { title: '我爱热干面' } },
		
		{ path: '/tabbar_index_index', name: 'tabbar_index_index', component:tabbar_index_index, meta: { title: '首页' }},
		{ path: '/tabbar_cart_index', name: 'tabbar_cart_index', component:tabbar_cart_index, meta: { title: '购物车' }},
		{ path: '/tabbar_goods_index', name: 'tabbar_goods_index', component:tabbar_goods_index, meta: { title: '商品' }},
		{ path: '/tabbar_user_index', name: 'tabbar_user_index', component:tabbar_user_index, meta: { title: '我的' }},
		{ path: '/shop_list', name: 'shop_list', component:shop_list, meta: { title: '门店列表' }},
		{ path: '/goods_detail', name: 'goods_detail', component:goods_detail, meta: { title: '商品详情' }},
		{ path: '/order_list', name: 'order_list', component:order_list, meta: { title: '订单列表' }},
		// { path: '/order_detail', name: 'order_detail', component:order_detail, meta: { title: '订单详情' }},
		{ path: '/order_confirm', name: 'order_confirm', component:order_confirm, meta: { title: '订单详情' }},
		{ path: '/order_addr_list', name: 'order_addr_list', component:order_addr_list, meta: { title: '地址列表' }},
		{ path: '/order_addr_edit', name: 'order_addr_edit', component:order_addr_edit, meta: { title: '地址编辑' }},
		{ path: '/user_login', name: 'user_login', component:user_login, meta: { title: '登录' }},
		{ path: '/common_web', name: 'common_web', component:common_web, meta: { title: '我爱热干面' }},
		{ path: '/user_liushui_list', name: 'user_liushui_list', component:user_liushui_list, meta: { title: '记录列表' }},
		
		
	]
});



// //引导页面
// router.beforeEach((to, from, next) => {
//   const hasSeenSplash = sessionStorage.getItem('hasStartPage');
//   if (!hasSeenSplash && to.path !== '/start_page') {
//     // 如果没看过引导页，且当前不是去引导页，就跳过去
//     next('/start_page');
//   } else {
//     next(); // 否则正常放行
//   }
// });



export default router



// WEBPACK FOOTER //
// ./src/router/index.js